import { Component, OnInit, EventEmitter, Output, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { ContactsService } from '../../services/coreService/contacts.service';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { ModuleName } from '../../services/coreService/contact.enum';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-touches',
  templateUrl: './touches.component.html',
  styleUrls: ['./touches.component.scss']
})
export class TouchesComponent implements OnInit {

  transactionID: string;
  databaseId: string;
  organizationId: string;

  myTouchesForm: FormGroup;
  TouchesType :any[]=[];
  TouchesTypeForFilter :any[]=[];
  AllContactTouchesList  :any[]=[];
  folderList: any[] = [];
  modulename:string;
  folderId:number=0;
  currentUser: any;

  getTagListResponseHolder: any;


  AllCoreTouchesList:any[]=[];
  AllCoreTouchesListShow:boolean=false;

  showTouches:boolean = true;
  @Output() showCreate = new EventEmitter<boolean>();
  OfficeIDList: any=[];
  myOfficeID: any;
  clickEventNextPreviousForTouchesFromContact:any;


  constructor(private dialog: MatDialog, private formBuilder: FormBuilder,
    private statusConst: StatusConstant, private contactsService: ContactsService,  
    private toastr: ToastrService, private settingService: SettingService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private cdr: ChangeDetectorRef,private router: Router,private _dataSharingService: DataSharingService,
    private sanitizer: DomSanitizer) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);  
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }

  ngOnDestroy() {
    this.clickEventNextPreviousForTouchesFromContact.unsubscribe();    
  }
  
  ngOnInit(): void {   
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if(Module.length>0){    
     this.folderId = Module[0].folderID;
    }        
    this.transactionID = sessionStorage.getItem('transactionID');  

    this.clickEventNextPreviousForTouchesFromContact = this._dataSharingService.getNextPreviousForTouchesFromContact().subscribe((result) => {
      if (result) {
        this.getAllTouchesList();       
      }
    }); 

    this.getAllTouchesList();    
  }  
   
  editTouch(touch:any){
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:ModuleName.Contact,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        touch:touch
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getAllTouchesList();
      }      
    });
  }
 

  deleteTouch(touch:any){
    const message = `Are you sure you want to delete this activity ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {      
           let model={
            "touchesID": [
              touch.touchID
            ],
              transactionID:Number(sessionStorage.getItem('transactionID')),
              databaseId:Number(this.databaseId),
              organizationID:Number(this.organizationId),
              userID:this.currentUser.UID,
              officeID: this.myOfficeID
          }
          this.contactsService.DeleteContactTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) { 
                this.getAllTouchesList();
                this.toastr.success("Deleted successfully.", '', {
                  timeOut: 3000,
                });  
              }
              else {
               
              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });     
  }

  // get Activity List
  getAllTouchesList() {
    var ReqModel={
      folderID:this.folderId,
      transactionID:Number(sessionStorage.getItem('transactionID')),
      documentID:null,
      databaseId:Number(this.databaseId),
      organizationID:Number(this.organizationId),
      userID:this.currentUser.UID,
      officeID: this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
    }
     this.contactsService.GetAllContactTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) { 
          this.getTagListResponseHolder = response.data;
          if(this.getTagListResponseHolder !=null){
            this.getTagListResponseHolder.map((res) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName
                );
              }
              if (res.byPortal != null) {
                let toArray =  res.byPortal.split("@");         
                res.createdByFirstName = toArray[0];
               }
               if (res.touchNote != null) {
                res.touchNote1=  res.touchNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                res.touchNoteNew = this.makeLinksClickable(res.touchNote1);
                // res.touchNoteNew = this.makeLinksClickable(res.touchNote);
              }  
              return res;
            });  
          }         
          this.AllCoreTouchesList = this.getTagListResponseHolder;
          if(this.AllCoreTouchesList!=null){
            this.AllCoreTouchesListShow=true;
          }else{
            this.AllCoreTouchesListShow=false;
          }              
        }
        else {
         
        }
      }
    });
  }

  makeLinksClickable(text: string): SafeHtml {
    if (!text) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
  
    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
  
    // Replace URLs with anchor tags
    const modifiedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  
    // Sanitize the resulting HTML
    return this.sanitizer.bypassSecurityTrustHtml(modifiedText);
  }

 // get touch type ==//
 getTouchTypeList() {
  this.TouchesType=[];
 var ReqModel={
   databaseId:Number(this.databaseId),
   organizationID:Number(this.organizationId),
   officeID: this.myOfficeID,
  }
  this.settingService.getAllTouchTypeList(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.TouchesType = this.getTagListResponseHolder.data;

        var newlist =[];
        var ReqModels ={         
           touchTypeID: 0,
           touchName: "All"
        }
        this.TouchesTypeForFilter.push(ReqModels);
        newlist = this.getTagListResponseHolder.data;
        for (var i = 0, len = newlist.length; i < len; ++i) {
          this.TouchesTypeForFilter.push(newlist[i]);
       }   
      }
      else {
        
      }
    }
  });
}

onChangeSelectedType(touchTypeID) {
  if(touchTypeID == 0){
    this.getAllTouchesList();
  }
  else {
  var ReqModel={
    folderID:this.folderId,
    transactionID:Number(sessionStorage.getItem('transactionID')),
    documentID:null,
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    userID:this.currentUser.UID,
    touchesType:touchTypeID.value
  }
  this.contactsService.GetAllContactTouches(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {  
        
        this.getTagListResponseHolder = response.data;
        if(this.getTagListResponseHolder!=null){
          this.getTagListResponseHolder.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
            }
            return res;
          });
        }          
        this.AllCoreTouchesList = this.getTagListResponseHolder;               
      }
      else {
       
      }
    }
  });
 }
}


   
  addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:ModuleName.Contact,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
        this.getAllTouchesList();
      }
    });   
  }
 

  close() {   
    this.dialog.closeAll();
  }

  
  getTimeSpent(touch:any): any{
    if(touch.startDate && touch.touchDate ){
 
     const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
 
     let startDate = new Date(touch.startDate).valueOf();
     let endDate = new Date(touch.touchDate).valueOf();
     const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));
    
 
       if(diffDays){
         return `${diffDays}`
       }
       else{
         return ""
       }
   }
 }


 addEmailAction() {
  const dialogRef = this.dialog.open(AddEmailActionComponent, {     
    data: {
      moduleName:ModuleName.Contact,      
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result!=null && result!=undefined){
      this.getAllTouchesList();
    }      
  });
} 

}
